import { Button, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { UserIcon } from '@heroicons/react/24/outline';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'softcat:hooks/use-auth.ts';

export const HeaderNavItemUser = () => {
    const { user, signOut } = useAuth();

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <MenuButton
                    className="inline-flex rounded-full bg-white p-2 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    data-testid="user-selector"
                >
                    <UserIcon className={'size-6 stroke-1 text-gray-600'} />
                </MenuButton>
            </div>

            <MenuItems
                className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                transition
            >
                {user && (
                    <div className={'min-w-40 bg-gray-50 px-4 py-2 text-xs font-semibold text-gray-500'}>
                        <FormattedMessage id={'HEADER_NAV_ITEM_USER_SIGNED_IN'} /> <strong>{user.email || user.username}</strong>
                    </div>
                )}

                <MenuItem>
                    <Button
                        className="flex w-full items-center gap-x-1.5 px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                        onClick={signOut}
                    >
                        <FormattedMessage id={'HEADER_NAV_ITEM_USER_LOGOUT'} />
                    </Button>
                </MenuItem>
            </MenuItems>
        </Menu>
    );
};
